// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","443":"about","445":"person"}[chunkId] + "." + {"176":"fe033d54","443":"2cee93b4","445":"5000a0d8"}[chunkId] + ".js";
};